// extracted by mini-css-extract-plugin
export default {"title":"EditModal_title__dwOE8","desc":"EditModal_desc__ksmyB"};